import { pizzasTomate, pizzasCreme } from "../data/menu";

const FALLBACK =
  "https://images.unsplash.com/photo-1621510564330-c87695020b53?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxwaXp6YSUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3ODk3MTAzM3ww&ixlib=rb-4.1.0&q=85";

// Sélectionne 8 pizzas pour la galerie ; on garde celles avec photo extraite
const SELECTION_NAMES = [
  "Margherita",
  "Regina",
  "Spéciale Pizzaïolo",
  "Bufala",
  "Hawaïenne",
  "Siciliana",
  "Savoyarde",
  "Fruits de mer",
];

export default function Gallery() {
  const all = [...pizzasTomate, ...pizzasCreme];
  const items = SELECTION_NAMES.map((n) => all.find((p) => p.name === n)).filter(
    Boolean,
  );

  return (
    <section
      id="galerie"
      data-testid="gallery-section"
      className="relative py-24 lg:py-32 bg-[#1a1a1a] text-white overflow-hidden"
    >
      <div className="absolute inset-0 grain-bg opacity-30" aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-[0.32em] text-[#f6c177] mb-4">
              <i className="fa-regular fa-image mr-2"></i>
              Galerie
            </p>
            <h2
              data-testid="gallery-title"
              className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight"
            >
              Le four nous le rend bien.
            </h2>
          </div>
          <p className="text-white/70 max-w-md text-base">
            Quelques-unes de nos pizzas signature, telles qu'elles sortent de
            notre four. Direct du PDF de la carte, pas de filtre.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
          {items.map((p, i) => (
            <a
              key={p.slug}
              href="#menu"
              data-testid={`gallery-item-${p.slug}`}
              className={`group relative overflow-hidden rounded-2xl bg-[#0f0f10] ${
                i === 0 ? "row-span-2 col-span-2 aspect-square md:aspect-auto" : "aspect-square"
              }`}
            >
              <img
                src={p.img || FALLBACK}
                onError={(e) => {
                  e.currentTarget.src = FALLBACK;
                }}
                alt={p.name}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-5">
                <p className="text-[10px] uppercase tracking-[0.24em] text-[#f6c177]">
                  Notre carte
                </p>
                <h3 className="font-serif text-xl sm:text-2xl mt-1">
                  {p.name}
                </h3>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-16 flex justify-center">
          <a
            href="/pizzas/cartes-originale.pdf"
            download
            data-testid="gallery-pdf-download"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full border border-white/30 bg-white/10 hover:bg-white/20 transition-colors text-white"
          >
            <i className="fa-solid fa-file-pdf text-[#f6c177] text-xl"></i>
            <span className="flex flex-col text-left">
              <span className="text-xs uppercase tracking-[0.22em] text-[#f6c177]">
                La carte originale
              </span>
              <span className="font-serif text-xl mt-0.5">
                Télécharger la carte complète
              </span>
            </span>
            <i className="fa-solid fa-arrow-down-to-bracket ml-2 text-white/60"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
